import '../App.css';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CloseIcon from '@mui/icons-material/Close';
import { useRef, useEffect, useState, useMemo } from 'react';
import { MapContainer, Marker, TileLayer, Tooltip } from 'react-leaflet';
import { useNavigate, useParams } from 'react-router-dom';
import { areas } from './hotspots';
import Passeio from './passeio';
import { gql, useApolloClient } from "@apollo/client";

const GET_DATA_PAGINATED = gql`
  query GetMicronarrativas($after: String, $first: Int = 100, $order: OrderEnum = ASC) {
    micronarrativas(first: $first, after: $after, where: { orderby: { field: DATE, order: $order } }) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          id
          title
          micronarrativasMeta {
            hotspot
            data
            latitude
            longitude
            tags_micro {
              edges {
                node {
                  id
                  name
                }
              }
            }
            narrativa
            imagem {
              node {
                mediaItemUrl
              }
            }
            autor
          }
        }
      }
    }
  }
`;

export function useHotspotData(area) {
  const client = useApolloClient();
  const [state, setState] = useState({
    loading: true,
    error: null,
    data: [],
  });

  useEffect(() => {
    let cancelled = false;

    async function fetchAll() {
      let after = null;
      const allEdges = [];

      try {
        do {
          const { data } = await client.query({
            query: GET_DATA_PAGINATED,
            variables: { after, first: 100, order: "ASC" },
            fetchPolicy: "network-only",
          });

          const conn = data?.micronarrativas;
          if (!conn) break;

          allEdges.push(...(conn.edges || []));
          after = conn.pageInfo?.endCursor || null;


          if (!conn.pageInfo?.hasNextPage) break;
        } while (true);

        if (cancelled) return;

        console.log(`Finished fetching all entries: ${allEdges.length} total`);

        const hs = areas.filter((item) => item.area === area);

        const filtered = allEdges
        .filter(({ node }) => hs.some(h => h.hotspot === node.micronarrativasMeta.hotspot[0]) )
          .map(({ node }) => ({
            id: node.id,
            narrativa: node.micronarrativasMeta?.narrativa || "",
            data: node.micronarrativasMeta?.data || "",
            tags: node.micronarrativasMeta?.tags_micro?.edges || [],
            imagem: node.micronarrativasMeta?.imagem?.node?.mediaItemUrl || "",
            autor: node.micronarrativasMeta?.autor || "",
          }));


        setState({ loading: false, error: null, data: filtered });
      } catch (error) {
        if (cancelled) return;
        setState({ loading: false, error, data: [] });
      }
    }

    setState((s) => ({ ...s, loading: true }));
    fetchAll();

    return () => {
      cancelled = true;
    };
  }, [client, area]);

  return state;
}

export default function AreaPage(){
    const [index, setIndex] = useState(0);
    const [popupOpen, setPopupOpen] = useState(false);
    const { area } = useParams(); 
    const hotspots = areas.filter((item) => item.area === area);
    const { loading, error, data: micronarrativas } = useHotspotData(area);
    const popup = useRef(null);
    const navigate = useNavigate();

    const handleTagClick = (tag) => {
      window.open(`/tags/${tag}`, '_blank');
    };

    const handleClick = (id) => {
      setIndex(id);
      setPopupOpen(true);
    }

    const popupClose = () => {
      setIndex(null);
      setPopupOpen(false);
    }

    return (
    <div className='tag-wrapper'>
      <Passeio></Passeio>
      <button className="back-button" onClick={() => navigate("/")}>
        <ArrowBackIcon/>
        <span>Áreas</span>
      </button>
      <div className='tag-gallery'>
        <div className='title-page'>
          {area}
        </div>
        {
        micronarrativas.map((item, id) => (
          <div onClick={() => handleClick(id)} className='tag-thumb' key={id}>
            <img key={id} src={item.imagem} alt={`Thumbnail ${id}`} />
          </div>
        ))
      }
      </div>
      {popupOpen && <div ref={popup} className='popup open-popup-tag' onClick={popupClose}>
        <div className='popup-wrapper' onClick={(e) => e.stopPropagation()}>
          <div className='close-popup' onClick={popupClose}>
            <CloseIcon></CloseIcon>
          </div>
        <div className='imagem-tag'> 
          <img src={index === null ? null : micronarrativas[index].imagem } alt="Selected" />
        </div>
        <div className='narrativa-popup'>
          <div className='Corpo'>
            <div>
              <span>{index === null ? null : micronarrativas[index].narrativa}</span>
            </div>
            <div className='Sub-texto'>
              Por <span>{micronarrativas[index].autor}</span> - 
              <span>
                {new Date(micronarrativas[index].data).toLocaleDateString('pt-BR', {
                    timeZone: 'UTC'
                })}
              </span>
            </div>
            <div className='Tags'>
              {index === null ? null : micronarrativas[index].tags.map(({ node, id }) => (
                <span
                  key={id}
                  className='Tag'
                  onClick={() => handleTagClick(node.name)}
                  style={{ cursor: 'pointer' }}
                >
                {node.name}
                </span>
              ))}
            </div>
          </div>
                    <div style={{ height: '150px', width: '100%' }} >
                      <MapContainer
                        center={hotspots[0].geo}
                        zoom={15}
                        scrollWheelZoom={false}
                        zoomControl={false}
                        dragging={false} 
                        style={{ height: '150px', width: '100%' }}
                      >
                        <TileLayer
                          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        />
                        <Marker position={hotspots[0].geo}>
                          <Tooltip direction="top" offset={[-15, -15]} opacity={1} permanent={false}>
                            {hotspots[0].area}
                          </Tooltip>
                        </Marker>
                      </MapContainer>
                  </div>
        </div>
        </div>
        </div>
      }
    </div>
    );
}